<template>
    <div
        class="transaction-finished"
        :class="{ '-vod': redirectType == 'marketplace_bills' }"
    >
        <div @click="leave" class="ready">
            <div class="logo">
                <img
                    :src="$env.getAppLogo().logo"
                    v-if="redirectType != 'marketplace_bills'"
                />
                <img
                    src="@/assets/img/vod_logo.svg"
                    v-if="redirectType == 'marketplace_bills'"
                />
            </div>
            <div class="title">{{ $t('BUTTON_CONTINUE_LONG') }}</div>
            <div>
                <ActionButton
                    :loading="loading"
                    :label="$t('BUTTON_CONTINUE_LONG')"
                    color="apple"
                ></ActionButton>
            </div>
        </div>
        <transition name="fade">
            <AppLoading v-if="initLoading"></AppLoading>
        </transition>
    </div>
</template>
<script>
import AppLoading from '@/components/tools/AppLoading'
export default {
    components: {
        AppLoading
    },
    data() {
        return {
            initLoading: true,
            loading: false,
            redirectType: ''
        }
    },
    methods: {
        leave() {
            if (this.loading) return
            this.loading = true
            const timeout = this.$Utils.isMobileDevice() ? 3000 : 0
            if (this.redirectType == 'marketplace_bills') {
                window.postMessage('paymentComplete', '*')
                setTimeout(
                    () => window.open('https://vod.akademialivekid.pl'),
                    timeout
                )
            } else {
                window.open(this.$env.getMainApp())
                setTimeout(() => this.$router.replace('/'), timeout)
            }
        },
        checkTransaction() {
            const transaction = this.$route.query.OrderID
            this.$axios
                .get(
                    `${process.env.VUE_APP_API_URL.replace(
                        '{region}',
                        'pl'
                    )}v1/transactions/${transaction}/type`
                )
                .then(({ data }) => {
                    this.redirectType = data
                })
                .catch(error => {
                    console.log(error)
                })
                .then(() => {
                    this.initLoading = false
                })
        }
    },
    mounted() {
        this.checkTransaction()
    }
}
</script>
<style lang="scss" scoped>
.ready {
    position: fixed;
    border-radius: $modal-radius;
    width: 400px;
    height: 250px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.title {
    font-size: 25px;
    font-family: $input-family;
}
.transaction-finished {
    height: 100%;
    width: 100%;

    &.-vod {
        background: #141414;
        color: #fff;
    }
}
.logo {
    max-width: 100%;
    margin: 20px auto;
    text-align: center;
}
.logo img {
    width: 180px;
}
@media (max-width: 400px) {
    .ready {
        width: 80%;
    }
    .title {
        font-size: 22px;
    }
}
</style>
